export interface StockItemReceiptMeasure {
  measureDescriptionId: string;
  measureDescription: string;
  quantity: number;
  unitOfMeasure: string;
  unitOfMeasureShort: string;
}
